export default "__VITE_ASSET__BVkPkVRx__"